import React, { useEffect, useRef, useState } from "react";
import "./Game_page_1.css";
import {
  faRotateLeft,
  faVolumeHigh,
  faWallet,
  faXmark,
  faVolumeXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, InputGroup } from "react-bootstrap";
import Roullate_win_loss_modal from "../../common_components/common_modal/roullate_win_loss_modal/Roullate_win_loss_modal";


function Game_page_1() {
  // ✅ Add reference for audioconst audioRef = useRef(null);       // background music
  const winSoundRef = useRef(null);    // win sound
  const loseSoundRef = useRef(null);   // lose sound
  const [isMuted, setIsMuted] = useState(false);
  const audioRef = useRef(null); // background music
  const spinSoundRef = useRef(null); // spin sound
  const [orbitDistance, setOrbitDistance] = useState(145);

  // Adjust orbit distance on resize
  useEffect(() => {
    const updateOrbit = () => {
      const width = window.innerWidth;
      if (width < 480) setOrbitDistance(90); // mobile
      else if (width < 768) setOrbitDistance(70); // tablet
      else if (width < 1024) setOrbitDistance(100); // small laptop
      else if (width < 1499) setOrbitDistance(80); // small laptop
      else setOrbitDistance(145); // desktop
    };
    updateOrbit();
    window.addEventListener("resize", updateOrbit);
    return () => window.removeEventListener("resize", updateOrbit);
  }, []);


  const toggleVolume = () => {
    setIsMuted((prev) => {
      const newMuted = !prev;
      if (audioRef.current) audioRef.current.muted = newMuted;
      if (spinSoundRef.current) spinSoundRef.current.muted = newMuted;
      return newMuted;
    });
  };

  const [showResultModal, setShowResultModal] = useState(false);
  const [isWin, setIsWin] = useState(false);
  const [resultMessage, setResultMessage] = useState(null);
  const [activeChip, setActiveChip] = useState("1");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [hoveredRange, setHoveredRange] = useState(null);
  const [hoveredColor] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [ballNumber, setBallNumber] = useState(null);
  const [ballAngle, setBallAngle] = useState(0);
  const [wheelAngle, setWheelAngle] = useState(0);

  const numbers = [
    0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6,
    27, 13, 36, 11, 30, 8, 23, 10, 5, 24,
    16, 33, 1, 20, 14, 31, 9, 22, 18, 29,
    7, 28, 12, 35, 3, 26,
  ];


  const isHighlighted = (cell, rowId) => {
    if (hoveredRow === rowId) return true;

    if (hoveredRange) {
      if (hoveredRange.start && cell.n >= hoveredRange.start && cell.n <= hoveredRange.end)
        return true;
      if (hoveredRange.type === "odd" && cell.n % 2 !== 0) return true;
      if (hoveredRange.type === "even" && cell.n % 2 === 0) return true;
      if (hoveredRange.color && hoveredRange.color === cell.c) return true;
    }

    return false;
  };


  const handlePlaceBet = (targetId) => {
    if (!activeChip) return;
    setPlacedBets(prev => [...prev, { id: targetId, chip: activeChip }]);
  };

  const getChipsForId = (id) => placedBets.filter((b) => b.id === id);

  const handleSpin = () => {
    if (spinning) return;
    if (placedBets.length === 0) {
      alert("Please place a bet before spinning!");
      return;
    }

    setSpinning(true);
    setResultMessage(null);






    // 🎯 Target number
    const betNumber = parseInt(placedBets[0].id);
    const targetNumber = numbers.includes(betNumber)
      ? betNumber
      : numbers[Math.floor(Math.random() * numbers.length)];

    setBallNumber(targetNumber);

    const targetIndex = numbers.indexOf(targetNumber);
    const degreesPerNumber = 360 / numbers.length;

    const totalDuration = 10000; // ms
    const startTime = Date.now();

    const wheelRotations = 6; // total spins for the wheel
    const ballRotations = 10; // ball spins faster at first

    const finalBallAngle = targetIndex * degreesPerNumber; // same direction now

    // ✅ Play spin sound only during rotation
    if (!isMuted && spinSoundRef.current) {
      spinSoundRef.current.currentTime = 0;
      spinSoundRef.current.play().catch(() => { });
    }


    let bounceAngle = 0;

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / totalDuration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // easing out

      // 🎡 Wheel — rotates smoothly
      const wheelAngleNow = eased * wheelRotations * 360;
      setWheelAngle(wheelAngleNow);

      // ⚪ Ball — rotates in same direction, slows down
      let baseBallAngle =
        (eased) * ballRotations * 360 + finalBallAngle + bounceAngle;

      // 💥 Bounce near the end (adds natural vibration)
      if (progress > 0.85 && progress < 1) {
        const bounce = Math.sin((progress - 0.85) * 25 * Math.PI) * 2;
        bounceAngle = bounce;
      }

      setBallAngle(baseBallAngle);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setSpinning(false);
        // ✅ Stop spin sound after rotation
        if (spinSoundRef.current) {
          spinSoundRef.current.pause();
          spinSoundRef.current.currentTime = 0;
        }

        const hasWin = placedBets.some(
          (b) => parseInt(b.id) === targetNumber
        );
        setIsWin(hasWin);
        setShowResultModal(true);
        setResultMessage(
          hasWin
            ? `🎯 You won! Ball landed on ${targetNumber}`
            : `😞 You lost! Ball landed on ${targetNumber}`
        );
        // ✅ Play corresponding sound (win/lose)
        if (!isMuted) {
          if (hasWin && winSoundRef.current) {
            winSoundRef.current.currentTime = 0;
            winSoundRef.current.play().catch(() => { });
          } else if (!hasWin && loseSoundRef.current) {
            loseSoundRef.current.currentTime = 0;
            loseSoundRef.current.play().catch(() => { });
          }
        }
      }
    };

    requestAnimationFrame(animate);
  };



  return (
    <>
      <section className="Game_page_1">
        <div className="row me-0 ms-0 justify-content-center">
          {/* Left Wheel */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6  col-10 p-0">
            <div className="casino_game_wheel_holder">
              <div className="wheel_img_holder">
                <div className="roulette_container" style={{ position: "relative" }}>
                  <img
                    src="/assets/images/game/Roulette-Wheel.png"
                    className="wheel_img"
                    style={{ transform: `rotate(${wheelAngle}deg)` }}
                    alt="roulette wheel"
                  />

                  {/* Numbers rotate with wheel */}
                  <div
                    className="wheel_numbers_container"
                    style={{ transform: `rotate(${wheelAngle}deg)` }}
                  >
                    {numbers.map((num, i) => {
                      const angle = -90 + (360 / numbers.length) * i;
                      const x = 165 * Math.cos((angle * Math.PI) / 180);
                      const y = 165 * Math.sin((angle * Math.PI) / 180);
                      return (
                        <div
                          key={num}
                          className={`wheel_number ${num === 0 ? "green_number" : i % 2 === 0 ? "red_number" : "black_number"}`}
                          style={{
                            position: "absolute",
                            top: `calc(50% + ${y}px)`,
                            left: `calc(50% + ${x}px)`,
                            transform: "translate(-50%, -50%)",
                          }}
                        >
                          {num}
                        </div>
                      );
                    })}
                  </div>

                  {/* Ball rotates along numbers only */}
                  <div
                    className="wheel_ball_img_holder orbit"
                    style={{
                      transform: `rotate(${ballAngle}deg) translateX(${orbitDistance}px) rotate(-${ballAngle}deg)`,
                      transition: spinning ? "none" : "transform 0.3s ease-out",
                    }}
                  >
                    <img
                      src="/assets/images/game/Roulette_Ball_Yellow.png"
                      className="wheel_ball_img"
                      alt="ball"
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* Right Table Board */}
          <div className="col-xl-9 col-lg-8 col-md-12 ">
            <div className="game_score_money_holder">
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <div className="score_boxes_holder">
                    <div className="box_hodler">1</div>
                    <div className="box_hodler">5</div>
                    <div className="box_hodler">21</div>
                    <div className="box_hodler">7</div>
                    <div className="box_hodler">4</div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-6">
                  <div className="money_field_volume_holder">
                    <div className="money_holder">
                      <InputGroup>
                        <Form.Control value={"₹. 15898.00"} readOnly />
                        <InputGroup.Text id="basic-addon2">
                          <FontAwesomeIcon icon={faWallet} />
                        </InputGroup.Text>
                      </InputGroup>
                    </div>

                    <div className="sound_icon_holder" onClick={toggleVolume}>
                      <FontAwesomeIcon
                        className="volume_icon"
                        icon={isMuted ? faVolumeXmark : faVolumeHigh}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Roulette Board */}
            <div className="casino_board_table_holder">
              <div>
                <table className="roulette_table">
                  <tbody>
                    {/* === ROWS AND CELLS === */}
                    {/* ROW 1 */}
                    <tr className="row_1">
                      <td rowSpan="3" className="zero_cell" onClick={() => handlePlaceBet("0")}>
                        <div className="zero_box">0</div>
                        {getChipsForId("0").map((chip, index) => (
                          <div
                            key={index}
                            className="placed_chip"
                            style={{ top: `${index * 5}px`, left: `${index * 5}px` }}
                          >
                            <img
                              src="/assets/images/game/chips.png"
                              className="placed_chip_img"
                              alt="chip"
                            />
                            <span className="placed_chip_value">{chip.chip}</span>
                          </div>
                        ))}
                      </td>

                      {[{ n: 3, c: "red" }, { n: 6, c: "black" }, { n: 9, c: "red" }, { n: 12, c: "red" }, { n: 15, c: "black" }, { n: 18, c: "red" }, { n: 21, c: "red" }, { n: 24, c: "black" }, { n: 27, c: "red" }, { n: 30, c: "red" }, { n: 33, c: "black" }, { n: 36, c: "red" }].map((cell, i) => (
                        <td key={i} onClick={() => handlePlaceBet(cell.n.toString())} className={`${cell.c} ${isHighlighted(cell, 1) ? "highlight" : ""}`} style={{ position: "relative" }}>
                          <div className={`${cell.c} ${cell.c}_circle_number`}>{cell.n}</div>
                          {getChipsForId(cell.n.toString()).map((chip, index) => (
                            <div key={index} className="placed_chip" style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
                              <img src="/assets/images/game/chips.png" className="placed_chip_img" alt="chip" />
                              <span className="placed_chip_value">{chip.chip}</span>
                            </div>
                          ))}
                        </td>
                      ))}

                      <td
                        className="side_cell"
                        onMouseEnter={() => setHoveredRow(1)}
                        onMouseLeave={() => setHoveredRow(null)}
                        onClick={() => handlePlaceBet("2:1_row1")}
                      >
                        2:1
                        {getChipsForId("2:1_row1").map((chip, index) => (
                          <div key={index} className="placed_chip" style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
                            <img src="/assets/images/game/chips.png" className="placed_chip_img" alt="chip" />
                            <span className="placed_chip_value">{chip.chip}</span>
                          </div>
                        ))}
                      </td>
                    </tr>

                    {/* ROW 2 */}
                    <tr className="row_2">
                      {[{ n: 2, c: "black" }, { n: 5, c: "red" }, { n: 8, c: "black" }, { n: 11, c: "black" }, { n: 14, c: "red" }, { n: 17, c: "black" }, { n: 20, c: "black" }, { n: 23, c: "red" }, { n: 26, c: "black" }, { n: 29, c: "black" }, { n: 32, c: "red" }, { n: 35, c: "black" }].map((cell, i) => (
                        <td key={i} onClick={() => handlePlaceBet(cell.n.toString())} className={`${cell.c} ${isHighlighted(cell, 2) ? "highlight" : ""}`} style={{ position: "relative" }}>
                          <div className={`${cell.c} ${cell.c}_circle_number`}>{cell.n}</div>
                          {getChipsForId(cell.n.toString()).map((chip, index) => (
                            <div key={index} className="placed_chip" style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
                              <img src="/assets/images/game/chips.png" className="placed_chip_img" alt="chip" />
                              <span className="placed_chip_value">{chip.chip}</span>
                            </div>
                          ))}
                        </td>
                      ))}

                      <td className="side_cell" onMouseEnter={() => setHoveredRow(2)} onMouseLeave={() => setHoveredRow(null)} onClick={() => handlePlaceBet("2:1_row2")}>
                        2:1
                        {getChipsForId("2:1_row2").map((chip, index) => (
                          <div key={index} className="placed_chip" style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
                            <img src="/assets/images/game/chips.png" className="placed_chip_img" alt="chip" />
                            <span className="placed_chip_value">{chip.chip}</span>
                          </div>
                        ))}
                      </td>
                    </tr>

                    {/* ROW 3 */}
                    <tr className="row_3">
                      {[{ n: 1, c: "red" }, { n: 4, c: "black" }, { n: 7, c: "red" }, { n: 10, c: "black" }, { n: 13, c: "black" }, { n: 16, c: "red" }, { n: 19, c: "red" }, { n: 22, c: "black" }, { n: 25, c: "red" }, { n: 28, c: "black" }, { n: 31, c: "black" }, { n: 34, c: "red" }].map((cell, i) => (
                        <td key={i} onClick={() => handlePlaceBet(cell.n.toString())} className={`${cell.c} ${isHighlighted(cell, 3) ? "highlight" : ""}`} style={{ position: "relative" }}>
                          <div className={`${cell.c} ${cell.c}_circle_number`}>{cell.n}</div>
                          {getChipsForId(cell.n.toString()).map((chip, index) => (
                            <div key={index} className="placed_chip" style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
                              <img src="/assets/images/game/chips.png" className="placed_chip_img" alt="chip" />
                              <span className="placed_chip_value">{chip.chip}</span>
                            </div>
                          ))}
                        </td>
                      ))}

                      <td className="side_cell" onMouseEnter={() => setHoveredRow(3)} onMouseLeave={() => setHoveredRow(null)} onClick={() => handlePlaceBet("2:1_row3")}>
                        2:1
                        {getChipsForId("2:1_row3").map((chip, index) => (
                          <div key={index} className="placed_chip" style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
                            <img src="/assets/images/game/chips.png" className="placed_chip_img" alt="chip" />
                            <span className="placed_chip_value">{chip.chip}</span>
                          </div>
                        ))}
                      </td>
                    </tr>

                    {/* Bottom Betting Areas */}
                    <tr>
                      <td className="side_cell_empty"></td>
                      {[{ label: "1 to 12", id: "1to12" }, { label: "13 to 24", id: "13to24" }, { label: "25 to 36", id: "25to36" }].map((item, i) => (
                        <td key={i} colSpan="4" className="bottom_big" onClick={() => handlePlaceBet(item.id)} onMouseEnter={() => setHoveredRange({ start: i * 12 + 1, end: (i + 1) * 12 })} onMouseLeave={() => setHoveredRange(null)} style={{ position: "relative" }}>
                          {item.label}
                          {getChipsForId(item.id).map((chip, index) => (
                            <div key={index} className="placed_chip" style={{ top: `${index * 5}px`, left: `${index * 5}px` }}>
                              <img src="/assets/images/game/chips.png" className="placed_chip_img" alt="chip" />
                              <span className="placed_chip_value">{chip.chip}</span>
                            </div>
                          ))}
                        </td>
                      ))}
                      <td className="side_cell_empty"></td>
                    </tr>
                    <tr>
                      <td className="side_cell_empty"></td>
                      {[
                        { label: "1 to 18", id: "1to18", range: { start: 1, end: 18 } },
                        { label: "EVEN", id: "even", range: { type: "even" } },
                        { label: "RED", id: "red", color: "red" },
                        { label: "BLACK", id: "black", color: "black" },
                        { label: "ODD", id: "odd", range: { type: "odd" } },
                        { label: "19 to 36", id: "19to36", range: { start: 19, end: 36 } },
                      ].map((item, i) => (
                        <td
                          key={i}
                          colSpan="2"
                          className={`${item.id === "red"
                            ? "red red_btn"
                            : item.id === "black"
                              ? "black black_btn"
                              : "bottom_small"
                            }`}
                          onClick={() => handlePlaceBet(item.id)}
                          onMouseEnter={() => {
                            if (item.color) setHoveredRange({ color: item.color });
                            else setHoveredRange(item.range);
                          }}
                          onMouseLeave={() => setHoveredRange(null)}
                          style={{ position: "relative" }}
                        >
                          {item.label}
                          {getChipsForId(item.id).map((chip, index) => (
                            <div
                              key={index}
                              className="placed_chip"
                              style={{ top: `${index * 5}px`, left: `${index * 5}px` }}
                            >
                              <img
                                src="/assets/images/game/chips.png"
                                className="placed_chip_img"
                                alt="chip"
                              />
                              <span className="placed_chip_value">{chip.chip}</span>
                            </div>
                          ))}
                        </td>
                      ))}
                      <td className="side_cell_empty"></td>
                    </tr>

                  </tbody>
                </table>

                {/* Chips Selector */}
                <div className="points_chips_holder">
                  {["1", "10", "100", "1K", "10K", "100K", "1M", "10M", "100M"].map((chip) => (
                    <div key={chip} className={`chips_img_holder ${activeChip === chip ? "active_chip" : ""}`} onClick={() => setActiveChip(chip)}>
                      <img src="/assets/images/game/chips.png" className="chips_img" alt="" />
                      <span className="chip_value">{chip}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Buttons */}
        <div className="bet_actions_wrapper">
          {[
            { label: "REBET", icon: "↺" },
            { label: "QUIT", icon: "✕" },
            { label: "UNDO", icon: <FontAwesomeIcon icon={faRotateLeft} /> },
            { label: "CLEAR", icon: <FontAwesomeIcon icon={faXmark} /> },
            {
              label: "DOUBLE",
              icon: (
                <span className="x2_icon">
                  <FontAwesomeIcon icon={faXmark} />
                  <span>2</span>
                </span>
              ),
            },
            { label: "SPIN", icon: "🎰", onClick: handleSpin },
          ].map((btn, index) => (
            <button key={index} className="bet_btn" onClick={btn.onClick}>
              <span className="btn_icon">{btn.icon}</span>
              <span className="btn_text">{btn.label}</span>
            </button>
          ))}
        </div>


      </section>

      <Roullate_win_loss_modal
        show={showResultModal}
        onHide={() => setShowResultModal(false)}
        isWin={isWin}
        winningNumber={ballNumber}
        winAmount={isWin ? 20000 : 0}
        betTypeHigh={true}
        betTypeEven={true}
      />


      <audio ref={spinSoundRef} src="/assets/sounds/spinSoundFile/roulette.mp3" />
      <audio ref={winSoundRef} src="/assets/sounds/spinSoundFile/win.mp3" />
      <audio ref={loseSoundRef} src="/assets/sounds/spinSoundFile/lose.mp3" />

    </>
  );
}

export default Game_page_1;
